import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import Button from '@mui/material/Button';

import { handleApiRequest, removeStorageRecord } from '../../api';
import useUserAuth from '../../hook/useUserAuth';
import CircularProgress from '@mui/material/CircularProgress';

import { LogoutOutlinedIcon } from '../customStyles/images';
import { PAGE } from '../../constants/url';
import { LOGOUT_SUCCESS } from '../../constants/alertMsg';

import theme from '../../theme';

const Logout = ({ variant }) => {
  const navigate = useNavigate();
  const { setUserAuth, setAuthStatusMsg } = useUserAuth();
  const [isLoading, setIsLoading] = useState(false);

  const handleLogout = () => {
    setIsLoading(true);

    handleApiRequest('loginout')
      .then(res => {
        removeStorageRecord();
        setAuthStatusMsg(LOGOUT_SUCCESS);
        setUserAuth(null);
        setIsLoading(false);
        navigate(PAGE.login.path);
      })
  }

  if (variant === 'desktop') {
    return (
      <Button
        fullWidth
        size="large"
        variant="text"
        color={variant === "desktop" ? "primary" : "grey"}
        startIcon={<LogoutOutlinedIcon />}
        endIcon={isLoading === true ? <CircularProgress size={16} color="inherit" /> : null}
        disabled={isLoading === true}
        onClick={handleLogout}
        sx={{ minWidth: '150px' }}
      >
        登出
      </Button>
    )
  }

  return (
    <Button
      variant="fill-red-light"
      startIcon={<LogoutOutlinedIcon />}
      endIcon={isLoading === true ? <CircularProgress size={16} color="inherit" /> : null}
      disabled={isLoading === true}
      onClick={handleLogout}
      sx={{
        fontSize: '1rem',
        width: '100%',
        minWidth: '80px'
      }}
    >
      登出
    </Button>
  );
};

export default Logout;